module.exports = __webpack_public_path__ + "static/media/14.1ef89626.jpg";